import Button from './Button';
import NewButton from './NewButton';

export { Button, NewButton };

export default Button;
